import { i18n } from '../../lang/i18n';
import { NavLink } from "react-router-dom";
import { renderIcon } from "../../common/Medias";
import { MethodActive, Version } from "../../common/Conf";
import LanguagesSwitch from "../../components/LanguagesSwitchComponent/LanguagesSwitch";
import MenuModel from "../../store/AppData/MenuModel";
import LocalDataStore from "../../common/LocalDataStore";
import Helpers, { appRefreshAndUpdate } from "../../common/Helpers";
import ScrollToTop from "../../components/ScrollToTop";
import TokenStore from "../../common/TokenStore";
import { useAppSelector } from "../../store/hooks";


export default function TabOptions()
{
    const appData = useAppSelector((state) => state.appData)

    function clearCache()
    {
        LocalDataStore.locationClear();
        LocalDataStore.cartClear();
        TokenStore.remove();
        appRefreshAndUpdate()
        Helpers.PageReload('');
    }

    function renderType(item: MenuModel, index: number)
    {
        switch (item.valueType) {
            case 'action':
            case 'page':
                return <li key={index} className="list-group-item container">
                    <NavLink to={"/page/" + item.value} className="link-btn">
                        <h6>{item.title}</h6>
                        <span className="float-right"><i className="fa fa-angle-right"></i></span>
                    </NavLink>
                </li>
            case 'link':
                return <li key={index} className="list-group-item container"><a href={item.value} target="blanc" className="link-btn">
                    <h6>{item.title}</h6>
                    <span className="float-right"><i className="fa fa-angle-right"></i></span>
                </a></li>
            case 'title':
                return <ul key={index} className="list-group">
                    <h5 className="text-center mt-5">{item.title}</h5>
                        {item.items.map((item, index) => (
                            renderType(item, index)
                        ))}
                    </ul>
            default:
                return null;
        }
    }

    return (
        <div style={{ padding: 15 }}>
            <ScrollToTop />
            <ul className="list-group">
                {MethodActive('menu_delivery_orders') && <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/deliver_orders" className="link-btn">
                                <div>{renderIcon('menu-orders')}</div>
                                <h5>{i18n.TabUser.MenuDeliveryOrders}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>}
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/loyalty" className="link-btn">
                                <div>{renderIcon('menu-loyalty')}</div>
                                <h5>{i18n.TabUser.MenuLoyaltyProgram}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/invoices" className="link-btn">
                                <div>{renderIcon('menu-invoices')}</div>
                                <h5>{i18n.TabUser.MenuInvoices}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/user/recommend_friends" className="link-btn">
                                <div>{renderIcon('menu-invite-friend')}</div>
                                <h5>{i18n.TabUser.MenuInviteAFriend}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
                <li className="list-group-item container">
                    <div className="row">
                        <div className="col">
                            <NavLink to="/recipes" className="link-btn">
                                <div>{renderIcon('menu-recipes')}</div>
                                <h5>{i18n.Recipes.Title}</h5>
                                <span className="float-right"><i className="fa fa-angle-right"></i></span>
                            </NavLink>
                        </div>
                    </div>
                </li>
            </ul>
            <br />
            {appData.menus.map((item, index) => (
                renderType(item, index)
            ))}
            <br />
            <h5 className="text-center mt-5">{i18n.TabOptions.Others}</h5>
            <ul className="list-group">
                <li className="list-group-item container" onClick={clearCache}>
                    <div className="link-btn">
                        <h6>{i18n.TabOptions.ClearCache}</h6>
                        <span className="float-right"><i className="fa fa-angle-right"></i></span>
                    </div>
                </li>
            </ul>
            <br />
            <LanguagesSwitch />
            <br />
            <div className='text-center'>v:{Version}</div>
        </div>
    )
}